import React from 'react';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { IArrowProps } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultArrow';

import * as ST from './styled';

export const CustomArrows = ({ previousSlide, nextSlide }: IArrowProps) => (
    <ST.Wrapper onClick={previousSlide || nextSlide}>
        <ST.Arrow direction={previousSlide ? 'left' : 'right'}/>
    </ST.Wrapper>
);

export const CustomArrowsWithShowAll = ({ previousSlide, nextSlide }: IArrowProps) => (
    <ST.Wrapper onClick={previousSlide || nextSlide}>
        {previousSlide && <ST.ShowAllButton
            text='Посмотреть все'
            size={btnSizes.SMALL}
            type={btnTypes.SECONDARY}
            href='/promo'
        />}
        <ST.Arrow direction={previousSlide ? 'left' : 'right'}/>
    </ST.Wrapper>
);
